exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".even {\n    background-color:#e6e6e6;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/reimbursement/reimbursement-manager-view/reimbursement-manager-view.component.css
// module id = ../../../../../src/app/reimbursement/reimbursement-manager-view/reimbursement-manager-view.component.css
// module chunks = main